import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from '../images/techStart.png';
import breakpoint from "../helpers/breakpoints";
import UserMenu from '../elements/UserMenu';

const Header = (props) => {

  const { pathname: path } = useLocation();
  const role = props?.currentUser?.optional?.role
  const isNew = props?.currentUser?.optional?.groups && props?.currentUser?.optional?.groups?.some(el => el.includes('FREE'));
  return (
    <header className={`${['XS', 'S'].includes(breakpoint()) ? 'header-sm' : 'header'}`}
      style={{ display: 'flex', justifyContent: 'space-evenly' }}>

      <div className="header-logo-container header-logo-text">
        <img src={logo} className="header-logo" alt="header logo" />
        {['L', 'M'].includes(breakpoint()) ? null : <div>TechStart.dev</div>}
      </div>

      <div className="header-menu-container">
        {['S', 'XS'].includes(breakpoint()) ?
          null :
          <div id='header-buttons-container'>
            <Link to={"/"}>
              <span className={`menu-option${breakpoint() === 'XS' ? '-xs' : ''} ${path === '/' ? 'menu-option-selected' : ''}`}>
                {breakpoint() === 'XS' ?
                  <span className="header-xs-buttons">Home</span>
                  :
                  'Home'
                }
              </span>
            </Link>
            {role || isNew ?
              <Link to={"/lessons"}>
                <span className={`menu-option${breakpoint() === 'XS' ? '-xs' : ''} ${path === '/lessons' ? 'menu-option-selected' : ''}`}>
                  {breakpoint() === 'XS' ?
                    <span className="header-xs-buttons">Courses</span>
                    :
                    'Courses'
                  }
                </span>
              </Link> : null}
            {role &&
              <Link to={"/codewars"}>
                <span className={`menu-option${breakpoint() === 'XS' ? '-xs' : ''} ${path === '/codewars' ? 'menu-option-selected' : ''}`}>
                  {breakpoint() === 'XS' ?
                    <span className="header-xs-buttons">CodeWars</span>
                    :
                    'CodeWars'
                  }
                </span>
              </Link>}
            {/* {props.currentUser && props.currentUser.optional && props.currentUser.optional.role &&
              <Link to={"/projects"}>
                <span className={`menu-option ${path === '/projects' ? 'menu-option-selected' : ''}`}>Projects</span>
              </Link>} */}
            {props.currentUser && props.currentUser.optional && props.currentUser.optional.role === 'admin' &&
              <>
                <Link to={"/user/search"}>
                  <span className={`menu-option${breakpoint() === 'XS' ? '-xs' : ''} ${path === '/user/search' ? 'menu-option-selected' : ''}`}>
                    {breakpoint() === 'XS' ?
                      <span className="header-xs-buttons">Users</span>
                      :
                      'Users'
                    }
                  </span>
                </Link>
                <Link to={"/tracking"}>
                  <span className={`menu-option${breakpoint() === 'XS' ? '-xs' : ''} ${path === '/tracking' ? 'menu-option-selected' : ''}`}>
                    {breakpoint() === 'XS' ?
                      <span className="header-xs-buttons">Tracking</span>
                      :
                      'Tracking'
                    }
                  </span>
                </Link>
              </>
            }
          </div>
        }


        <UserMenu {...props} />

      </div>
    </header >
  );
}

export default Header;
